import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import { Theme } from '../../config/theme';

const ANIMATION = require('./animation.gif');

export default class Loader extends Component {
  render() {
    return (
      <div className={css(styles.overlay)}>
        <div className={css(styles.container)}>
          <img
            src={ANIMATION}
            alt="Loading"
            className={css(styles.image)}
            width={150}
            height={150} />
          <div className={css(styles.label)}>{this.props.text ? this.props.text : 'Fetching...'}</div>
        </div>
      </div>
    );
  }
}

Loader.defaultProps = {
  text: 'Fetching...',
};

Loader.propTypes = {
  text: PropTypes.string,
};

const bounceKeyframes = {
  from: {
    transform: 'scale(2)',
    animationTimingFunction: 'ease-in',
  },

  to: {
    transform: 'scale(0.8)',
    animationTimingFunction: 'cubic-bezier(0, 0, 0, 1)',
  },
};

const bounceShadowKeyframes = {
  from: {
    transform: 'scale(2.5, 2.6) translateY(-50%)',
    animationTimingFunction: 'ease-in',
  },
  to: {
    transform: 'scale(0.5) translateY(0)',
    animationTimingFunction: 'cubic-bezier(0, 0, 0, 1)',
  },
};

const styles = StyleSheet.create({
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 500,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    width: '100vw',
  },
  container: {
    padding: '50px 60px 50px',
    width: 300,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    backgroundColor: Theme.white,
    borderRadius: 5,
    boxShadow: '0 3px 4px 0 rgba(0, 0, 0, 0.25)',
    border: 'solid 1px #e4e4e4',
  },
  image: {

  },
  label: {
    display: 'block',
    marginTop: 50,
    textAlign: 'center',
    fontSize: 30,
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,
  },
  ball: {
    position: 'relative',
    width: 32,
    height: 32,
    borderRadius: '50%',
    zIndex: 0,
    outline: 'none',

    ':after': {
      content: '""',
      position: 'absolute',
      display: 'block',
      top: 0,
      left: 0,
      height: '100%',
      width: '100%',
      borderRadius: '50%',
      boxShadow: 'inset 0 -8px 0 0 rgba(0,0,0, 0.2)',
      background: '#56C5FF',
      zIndex: 1,
      animationName: bounceKeyframes,
      animationDuration: '600ms',
      animationIterationCount: 'infinite',
      animationDirection: 'alternate',
    },

    ':before': {
      content: '""',
      position: 'absolute',
      display: 'block',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      background: 'rgba(0,0,0, 0.05)',
      animationName: bounceShadowKeyframes,
      animationDuration: '600ms',
      animationIterationCount: 'infinite',
      animationDirection: 'alternate',
      zIndex: -10,
    },
  },
});



// WEBPACK FOOTER //
// ./src/components/Loader/index.js